var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9051 4.88727V22.9975C26.9051 23.0997 26.88 23.2002 26.8322 23.2904C26.7843 23.3807 26.715 23.4578 26.6305 23.515C26.5459 23.5723 26.4486 23.6079 26.347 23.6189C26.2455 23.6298 26.1428 23.6157 26.048 23.5778L14.4051 18.9206L24.8258 6.18414C24.8453 6.16005 24.8551 6.12959 24.8534 6.09866C24.8517 6.06774 24.8386 6.03856 24.8165 6.01676C24.7945 5.99497 24.7652 5.98213 24.7343 5.98072C24.7033 5.97931 24.673 5.98944 24.6491 6.00914L10.6551 17.6706L3.54846 15.6401C3.4253 15.6049 3.31593 15.5327 3.23515 15.4333C3.15437 15.3339 3.10609 15.2121 3.09685 15.0843C3.0876 14.9566 3.11783 14.8291 3.18345 14.719C3.24907 14.609 3.3469 14.5218 3.46371 14.4693L26.0236 4.31727C26.1188 4.27443 26.2232 4.25611 26.3273 4.26399C26.4313 4.27187 26.5318 4.30569 26.6195 4.36237C26.7071 4.41905 26.7792 4.49678 26.8291 4.58847C26.879 4.68016 26.9051 4.78288 26.9051 4.88727ZM12.8301 25.2846C12.8613 25.3939 12.9218 25.4926 13.0049 25.5701C13.088 25.6475 13.1907 25.7009 13.3019 25.7244C13.4131 25.7478 13.5286 25.7406 13.6359 25.7033C13.7433 25.666 13.8385 25.6002 13.9112 25.5129L16.8443 21.9933L11.2668 19.8133L12.8301 25.2846Z",
    fill: "url(#paint0_linear_343_7066)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_7066",
    x1: 15.0001,
    y1: 4.26221,
    x2: 15.0001,
    y2: 25.7379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentMsgIcon);
export default __webpack_public_path__ + "static/media/sentMsgIcon.ddfe5d81c4ed6121a5870d00bd393511.svg";
export { ForwardRef as ReactComponent };